import { tv } from '~/utils/tv'

export const InputMultiSelectLabelVariants = tv({
  base: `
      w-full align-middle m-none p-none
      text-left font-rdmodern font-regular tracking-tiny text-text-neutral text-nowrap truncate leading
      `,
  variants: {
    size: {
      md: 'text-threepulse leading-[150%]',
      ml: 'text-threeandhalfpulse leading-[140%]',
      lg: 'text-threeandhalfpulse leading-[140%]',
      xl: 'text-threeandhalfpulse leading-[140%]',
    },

    readOnly: {
      true: '',
      false: '',
    },
    disabled: {
      true: 'cursor-not-allowed text-text-neutral-disabled',
      false: '',
    },
  },
  compoundVariants: [
    {
      readOnly: true,
      disabled: false,
      class: 'cursor-not-allowed text-text-neutral-readonly',
    },
  ],
  defaultVariants: {
    disabled: false,
    readOnly: false,
  },
})
